import { Button, Grid } from '@mui/material'
import InputTextFieldUI from 'src/components/UI/inputTextField/inputTextField'
import ClientCaptcha from 'react-client-captcha'
import { useForm } from 'react-hook-form'
import { IObject } from 'src/models/interfaces'
import { FC, useState } from 'react'
import { smsService } from 'src/services/Sms'
import { toast } from 'react-toastify'
import { aW } from '@fullcalendar/core/internal-common'
import ButtonUiKit from 'src/components/UI/button'
import SubmitDialogAction from 'src/components/SubmitDialogAction/submitDialogAction'

export interface IResult {
  message: string
  username: string
}

interface IProps {
  setStep: () => void
  setResult: (result: IResult) => void
  onClose: () => void
}

const GetConfirmationCode: FC<IProps> = ({ setStep, setResult, onClose }) => {
  const [captchaCode, setCaptchaCode] = useState<string>()
  const [captchaKey, setCapcthaKey] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)
  const { getConfirmationCode } = smsService()

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm()

  const resetCaptcha = () => {
    setValue('captcha', '')
    setCapcthaKey(Math.floor(Math.random() * 1000) + 1)
  }

  const captchaIsValid = (): boolean => {
    if (getValues('captcha').toLowerCase().trim() !== captchaCode!.toLowerCase()) return false
    return true
  }

  const onSubmit = async (values: IObject) => {
    if (!captchaIsValid()) {
      toast.error('کد امنیتی صحیح نمی باشد')
      resetCaptcha()
      return
    }

    setLoading(true)

    try {
      const result = await getConfirmationCode(values.username)
      setResult({
        message: result.data!.mobile,
        username: values.username,
      })
      setStep()
    } catch {
      resetCaptcha()
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Grid xs={12} md={12} paddingTop={2} my={2}>
        <InputTextFieldUI
          labelText="نام کاربری و یا کد ملی"
          name="username"
          register={register}
          validation={{ required: true }}
          error={!!errors.username}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <ClientCaptcha key={captchaKey} retryIcon="/ReactIcons/retry.svg" captchaCode={(code: string) => setCaptchaCode(code)} />
      </Grid>
      <Grid item xs={6} sm={7}>
        <InputTextFieldUI
          placeholder="کد امنیتی"
          name="captcha"
          register={register}
          validation={{ required: true }}
          error={!!errors.captcha}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} my={2}>
        <SubmitDialogAction onClose={onClose} onSubmit={handleSubmit(onSubmit)} loading={loading} />
      </Grid>
    </>
  )
}

export default GetConfirmationCode
